// @ts-nocheck
import { getWaterPng } from '@/service'

const watermark = async ({ container = document.body, zIndex = 100000 } = {}): any => {
  const res = await getWaterPng()
  if (!res.data) {
    return false
  }
  const base64Url = res.data
  const wmInstance = document.querySelector('.__wm')

  const watermarkDiv = wmInstance || document.createElement('div')
  const styleStr = `
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width:100%;
    height:100%;
    z-index:${zIndex};
    pointer-events:none;
    background-repeat:repeat;
    background-image:url('data:image/png;base64,${base64Url}')`

  watermarkDiv.setAttribute('style', styleStr)
  watermarkDiv.classList.add('__wm')

  if (!wmInstance) {
    container.insertBefore(watermarkDiv, container.firstChild)
  }

  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
  if (MutationObserver) {
    let mo = new MutationObserver(() => {
      const wmInstance = document.querySelector('.__wm')
      // 只在wmInstance元素变动才重新调用 watermark
      if ((wmInstance && wmInstance.getAttribute('style') !== styleStr) || !wmInstance) {
        // 避免一直触发
        mo.disconnect()
        mo = null
        // eslint-disable-next-line no-undef
        const [args] = arguments
        watermark(JSON.parse(JSON.stringify(args)))
      }
    })

    mo.observe(container, {
      attributes: true,
      subtree: true,
      childList: true
    })
  }
}

export default watermark
